import Styles from '@/Components/Label/Label.module.scss';
import classNames from 'classnames';

export interface LabelProps {
    Name: string;
    Abbreviation: string;
    TextColor: string;
    BackgroundColor: string;
}

export function Label(props: Readonly<LabelProps>): React.ReactElement {
    const title = `${props.Name} - ${props.Abbreviation}`;
    return (
        <div className={classNames(Styles.item)} style={{ backgroundColor: props.BackgroundColor, color: props.TextColor }} title={title}>
            { props.Name }
        </div>
    );
}
